module.exports = __webpack_public_path__ + "img/gsnd2760_2.86defed1.svg";